import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import type { DropdownOption } from 'ui-components/components/dropdown/dropdown-types';
import Global from '../../../../store/global-selectors';

import { useProductDetailsContext } from '../../use-product-details-context';
import { messages } from '../../messages';

type ProductCategory = { categoryId: string; name: string };

const getOptionValue = (option: DropdownOption) => option.categoryId as string;
const getOptionLabel = (option: DropdownOption) => option.name as string;

export const ReportingCategoryDropdownV3 = () => {
  const { productCategoryId, setProductCategoryId, userHasPermission } = useProductDetailsContext();
  const productCategories = useSelector(Global.selectEntitiesProductCategories) as ProductCategory[];
  const intl = useIntl();

  const sortedCategories = useMemo(
    () => [...productCategories].sort((a, b) => a.name.localeCompare(b.name)) as DropdownOption[],
    [productCategories],
  );

  const onItemSelected = useCallback(
    (value: string | undefined) => {
      setProductCategoryId(value ?? '');
    },
    [setProductCategoryId],
  );

  return (
    <SearchableDropdownField
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      id='reporting-category-dropdown'
      isClearable
      isDisabled={!userHasPermission}
      onItemSelected={onItemSelected}
      options={sortedCategories}
      placeholder={intl.formatMessage(messages.productCategories)}
      selectedItemValue={productCategoryId}
    />
  );
};
